module.exports = __webpack_public_path__ + "media/images/GCS-mark-43c4280d17b37d1476030fb91021856c.png";